module.exports = __webpack_public_path__ + "img/income.bf47d454.svg";